import * as React from 'react';
import { useMergedRef } from '@sravni/react-utils';
import { Textarea } from '../../Textarea/src/Textarea.js';
import { TagModeView } from './TagModeView.js';

const InputView = React.forwardRef((props, ref) => {
    const { mode, children, inputProps, ...restProps } = props;
    if (mode === 'tags') {
        return React.createElement(TagModeView, { ...inputProps });
    }
    if (children) {
        const child = React.Children.only(children);
        const customInputProps = {
            ...restProps,
            ...inputProps,
            ...(typeof child.props === 'object' ? child.props : {}),
            // eslint-disable-next-line react-hooks/rules-of-hooks
            ref: useMergedRef(ref, child.ref),
        };
        return React.cloneElement(child, customInputProps);
    }
    return (React.createElement(Textarea, { ref: ref, ...restProps, ...inputProps }));
});

export { InputView };
//# sourceMappingURL=InputView.js.map
